<template>
  <layout :title="pageTitle">
    <div slot="add" class="d-flex align-center">
      <v-text-field
        v-model.number="form.blankPages"
        type="number"
        min="0"
        max="10"
        label="Blank pages"
        dense
        outlined
        hide-details
        class="mr-3"
        style="min-width: 140px; max-width: 140px"
      />
      <secondary-button class="mr-3" @click="addAccount"
        >Add account</secondary-button
      >
      <text-button class="mr-3" @click="$router.push({ name: 'dispute-letters' })"
        >Back</text-button
      >
      <primary-button :loading="generating" @click="download"
        >Download PDF</primary-button
      >
    </div>
    <identity-theft-report-editor
      v-if="allowed"
      ref="editor"
      :form="form"
      :template-def="templateDef"
    />
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import PrimaryButton from "@/components/ui/buttons/PrimaryButton.vue";
import SecondaryButton from "@/components/ui/buttons/SecondaryButton.vue";
import TextButton from "@/components/ui/buttons/TextButton.vue";
import IdentityTheftReportEditor from "@/components/identityTheftReport/IdentityTheftReportEditor.vue";
import {getIdtrTemplate} from "@/assets/constants/identity.theft.report.constants";
import {
  createAccount,
  createForm,
  downloadBase64Pdf,
  mergePrefill,
} from "@/assets/utils/identity.theft.report.utils";

const PREFILL_STORAGE_KEY = "idtr:prefill";

const readStoredPrefill = () => {
  try {
    const raw = localStorage.getItem(PREFILL_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export default {
  components: {
    Layout,
    PrimaryButton,
    SecondaryButton,
    TextButton,
    IdentityTheftReportEditor,
  },
  props: {
    prefill: {type: Object, default: null},
  },
  data() {
    const templateKey = this.$route.params.template;
    const templateDef = getIdtrTemplate(templateKey) || getIdtrTemplate("auto-loan");
    const base = createForm(templateDef.key);
    const prefill =
      this.prefill || this.$route.params.prefill || readStoredPrefill();
    return {
      templateDef,
      form: mergePrefill(base, prefill),
      generating: false,
      allowed: false,
    };
  },
  computed: {
    pageTitle() {
      return `Identity Theft Report: ${this.templateDef.name}`;
    },
  },
  created() {
    // Identity Theft Reports are limited to the Tier 1 wizard type.
    if (!this.isSendFaxAdmin || !getIdtrTemplate(this.$route.params.template)) {
      this.$router.replace({name: "dispute-letters"});
      return;
    }
    this.allowed = true;
  },
  methods: {
    addAccount() {
      this.form.accounts.push(createAccount());
    },
    async download() {
      this.generating = true;
      this.$loader.show();
      try {
        const result = await this.$refs.editor.generatePdf();
        if (result) downloadBase64Pdf(result.pdf, result.fileName);
      } catch (error) {
        this.$toast.error(error.message || "Failed to generate PDF");
      } finally {
        this.$loader.hide();
        this.generating = false;
      }
    },
  },
};
</script>
